import instance from '../../../../api/axios'
import {
  CreateIdea,
  Idea,
  IdeaListRequest,
  PaginatedIdeasResponse,
} from '../types/idea'

export const loadIdeas = async (): Promise<Idea[]> => {
  const response = await instance.get('/ideas')
  return response.data
}

export const loadIdeaList = async (
  request: IdeaListRequest,
): Promise<PaginatedIdeasResponse> => {
  const params: Record<string, string> = {
    page: String(request.page),
    limit: String(request.limit || 25),
  }

  if (request.filters.name.trim()) {
    params.name = request.filters.name.trim()
  }

  if (request.filters.tag.trim()) {
    params.tag = request.filters.tag.trim()
  }

  const response = await instance.get('/ideas/list', { params })
  return response.data
}

export const loadIdea = async (id: number): Promise<Idea> => {
  const response = await instance.get(`/ideas/${id}`)
  return response.data
}

export const saveIdea = async (idea: CreateIdea): Promise<Idea> => {
  const response = await instance.post('/ideas', idea)
  return response.data
}

export const modifyIdea = async (idea: Idea): Promise<Idea> => {
  const response = await instance.put('/ideas', idea)
  return response.data
}

export const removeIdea = async (id: number): Promise<number> => {
  const response = await instance.delete(`/ideas/${id}`)
  return response.data
}
